(ns frontend.ui.component.lp-portal.report.company.financial-performance.view
  (:require
   [common.time :as c-time]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view
    :refer
    [free-text-with-modal]]))

(defn financial-performance-card
  [financial-performance
   props]
  (let [{:keys [rich-content rich-content-path
                rich-content-completed-at rich-content-completed-path]}
        financial-performance
        {:keys [edit-mode? show-draft? save-text]} props]
    [card
     {:title "Financial performance"}
     [free-text-with-modal
      {:html-content      rich-content
       :completed-at      rich-content-completed-at
       :completed-path    rich-content-completed-path
       :complete-changed! (when (and edit-mode?
                                     (fn? save-text))
                            (fn [new-content completed?]
                              (save-text rich-content-path
                                         new-content
                                         rich-content-completed-path
                                         (if completed?
                                           ""
                                           (str (c-time/now-millis))))))
       :show-draft?       show-draft?
       :can-edit?         edit-mode?
       :on-change         (when (and edit-mode?
                                     (fn? save-text))
                            #(save-text rich-content-path %))}]]))
